import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var separator_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(Path, { d: "M4.5 12.5v4H3V7h1.5v3.987h15V7H21v9.5h-1.5v-4h-15Z" }) });
export {
  separator_default as default
};
//# sourceMappingURL=separator.js.map
